import React from 'react';

export default function MetricCard({ label, value }) {
  const display = value === undefined || value === null || value === '' ? 'Unavailable' : value;
  return (
    <div className="stat-card metric-card">
      <p className="stat-label">{label}</p>
      <p className={`stat-value ${display === 'Unavailable' ? 'muted' : ''}`}>{display}</p>
    </div>
  );
}
